<script setup lang="ts">
import { defineProps, defineEmits } from "vue";
import { Subscription } from "@/types/auth";
import { formatLocalDate } from "@/utils/date";
import { useI18n } from "vue-i18n";

defineProps<{
  subscription: Subscription;
  isLoading: boolean;
}>();
const emit = defineEmits(["cancelSubscription"]);

const { t } = useI18n();
</script>

<template>
  <div class="flex flex-col text-left content-container flex-wrap gap-y-4">
    <p class="bold-text">
      {{ t(`subscription.${subscription.calculator}.name`) }}
    </p>
    <div class="flex items-center justify-between">
      <div class="flex flex-col gap-1">
        <p class="text-base leading-[20px]">
          {{ t(`subscription.plans.${subscription.tiers[0]}`) }}
        </p>
        <p class="text-muted text-base leading-[20px]">
          {{
            t("subscription.plan-active-to", {
              date: formatLocalDate(subscription.period_end, "."),
            })
          }}
        </p>
      </div>
      <button
        v-if="subscription.ends_at === null"
        class="bg-ternary text-black px-4 py-2 rounded-full"
        :class="{
          'opacity-25 pointer-events-none': isLoading,
        }"
        @click="emit('cancelSubscription')"
      >
        {{ t("buttons.subscription.cancel-subscription") }}
      </button>
    </div>
  </div>
</template>

<style scoped>
.content-container {
  @apply px-4 py-3 border border-muted rounded-[20px];
}
.bold-text {
  @apply text-black font-semibold text-xl leading-[24px];
}
</style>
